module.exports = __webpack_public_path__ + "img/slide1.ca4aaf6c.png";